import { string } from "yup/lib/locale";

import { DetailsType } from "./form.type";
import { SelectionOptionItem } from "./listItems";

export type BankRule = {
    id?: string,
    ruleName?: string,
    appliesTo?: [],
    banks?: [],
    status?: string,
    includes?: string,
    detail?: string,
    condition?: string,
    value?: string,
    account?: string,
    accountId?: string,
    splitBy?: string,
    percentage?: number,
    amount?: number,
    memoEntity?: [],
    splitDetails?: Split[],
    conditions?: Condition[]
};

export type ConnectPlaidAccountsReq = {
  publicToken: string;
  username?: string;
  accounts: {
    id: string;
    name: string;
    fundId: string;
    ledgerId?: string;
    glAccountId?: string;
    startDate: string;
  }[];
};

export type Split = {
    detailValue?: number,
    detailAccount?: string,
};

export type Condition = {
    condition?: string,
    detail?: string,
    value?: string
};

export type SelectedBankRule = {
  bankRule?: BankRule;
  type?: DetailsType;
};

export enum BankRuleFilter {
  RuleName = 'ruleName',
  Bank = 'bank',
  AppliedTo = 'appliedTo',
    Status = 'status'
};

export enum BankRulesAction {
  ExportSelected = 'export_selected_data',
  InactivateSelected = 'inactivate_selected_data',
    ActivateSelected = 'activate_selected_data'
};

export type BankFilter = {
    id?: string,
    name?: string,
};

export const statusOptions: any = [
  {
    id: 'active',
        name: 'Active'   
    },{
    id: 'inactive',
        name: 'Inactive'
    }
];

export const appliesToOptions: any = [
  {
    id: 'inflow',
        name: 'Inflow'
    },{
    id: 'outflow',
        name: 'Outflow'
    }
];

export const appliesToAutoOptions: any = ['Inflow', 'Outflow'];

export const includesMenuOptions: any = ['Any Conditions', 'All Conditions'];

export const detailMenuOptions: any = ['Description', 'Bank Text', 'Amount'];

export const conditionMenuOptions: any = ['Contains', `Doesn't contain`, 'Is exactly'];

export const splitByOptions: SelectionOptionItem[] = [
  {
      id: "rb_percentage",
      label: "Percentage",
      value: "PERCENTAGE",
  },
  {
      id: "rb_amount",
      label: "Amount",
      value: "AMOUNT",
  },
];